export default "__VITE_ASSET__BxW0o3pj__"